module.exports = __webpack_public_path__ + "img/zanorari30.6750769b.jpg";